import {
  Box,
  Card,
  CardContent,
  Divider,
  TextField,
  Typography,
} from "@mui/material";

export default function TeamSeatRulesCard({
  config,
  summary,
  disabled,
  onMinimumSeatsChange,
  onMaximumSeatsChange,
}) {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: "16px",
        border: "1px solid #E2E8F0",
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box className="flex items-center gap-2 mb-4">
          <Box
            sx={{
              width: 8,
              height: 40,
              borderRadius: "4px",
              bgcolor: "#9333EA",
            }}
          />
          <Typography variant="h6" className="font-bold text-slate-900">
            Seat Rules
          </Typography>
        </Box>

        <Box className="space-y-4">
          <TextField
            fullWidth
            label="Minimum Seats"
            type="number"
            value={config.minimumSeatCount}
            onChange={onMinimumSeatsChange}
            helperText="Minimum number of team seats required"
            disabled={disabled}
          />

          <TextField
            fullWidth
            label="Maximum Seats"
            type="number"
            value={config.maximumSeatCount}
            onChange={onMaximumSeatsChange}
            helperText="Maximum number of team seats allowed"
            disabled={disabled}
          />

          <Divider sx={{ my: 2 }} />

          <Box
            sx={{
              mt: 3,
              p: 3,
              bgcolor: "#F8FAFC",
              borderRadius: "10px",
              border: "1px solid #E2E8F0",
            }}
          >
            <Typography
              variant="subtitle2"
              className="font-semibold text-slate-900 mb-2"
            >
              Pricing Calculator
            </Typography>
            <Box className="space-y-2">
              <Box className="flex justify-between">
                <Typography variant="body2" className="text-slate-600">
                  Minimum monthly cost:
                </Typography>
                <Typography
                  variant="body2"
                  className="font-semibold text-slate-900"
                >
                  ₦{summary.minTotal.toLocaleString()}
                </Typography>
              </Box>
              <Box className="flex justify-between">
                <Typography variant="body2" className="text-slate-600">
                  Maximum monthly cost:
                </Typography>
                <Typography
                  variant="body2"
                  className="font-bold text-blue-600"
                >
                  ₦{summary.maxTotal.toLocaleString()}
                </Typography>
              </Box>
              <Divider sx={{ my: 1 }} />
              <Typography variant="caption" className="text-slate-500">
                Min: {summary.minSeats} x ₦
                {Number(config.pricePerTeamMember).toLocaleString()} = ₦
                {summary.minTotal.toLocaleString()} /month
              </Typography>
              <Typography variant="caption" className="text-slate-500 block">
                Max: {summary.maxSeats} x ₦
                {Number(config.pricePerTeamMember).toLocaleString()} = ₦
                {summary.maxTotal.toLocaleString()} /month
              </Typography>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
